
import { createContext } from "react";

export const ViewContext = createContext( {

  view: 1,

  updateView: () => {},

} );
